// extracted by mini-css-extract-plugin
module.exports = {"buttonStyles":"PersonCanSee_buttonStyles__wbn42","headerBlock":"PersonCanSee_headerBlock__3rmAg","title":"PersonCanSee_title__1OYJP"};